import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { IFloatingFilterParams, TextFilterModel } from 'ag-grid-community';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../store';
export interface CustomParams extends IFloatingFilterParams {
    suppressFilterButton: boolean;
    color: string;
}
const mapStateToProps = (state: RootState) => ({
    actionTypes: state.activityLog.loggableActionTypes
});

type Props = ReturnType<typeof mapStateToProps> & CustomParams;

const ref = forwardRef((props: Props, ref) => {
    const [currentValue, setCurrentValue] = useState<string>('');
    const inputRef = useRef<HTMLInputElement>(null);

    // expose AG Grid Filter Lifecycle callbacks
    useImperativeHandle(ref, () => {
        return {
            onParentModelChanged(parentModel: TextFilterModel) {
                // When the filter is empty we will receive a null value here
                if (!parentModel) {
                    inputRef.current!.value = '';
                    setCurrentValue('');
                } else {
                    inputRef.current!.value = parentModel.filter + '';
                    setCurrentValue(parentModel.filter!);
                }
            }
        };
    });

    const onInputBoxChanged = (input: SelectChangeEvent<string>) => {
        if (input.target.value === '') {
            // Remove the filter
            props.parentFilterInstance(instance => {
                instance.onFloatingFilterChanged(null, null);
            });
            return;
        }

        setCurrentValue(input.target.value as string);
        props.parentFilterInstance(instance => {
            instance.onFloatingFilterChanged('equals', input.target.value);
        });
    };

    return (
        <>
            <Select
                ref={inputRef}
                sx={{ color: props.color }}
                value={currentValue}
                onChange={onInputBoxChanged}
            >
                {['', ...props.actionTypes].map(option => {
                    return (
                        <MenuItem key={option} value={option}>
                            {!option ? 'Inget filter' : option}
                        </MenuItem>
                    );
                })}
            </Select>
        </>
    );
});
ref.displayName = 'SelectFilterComponent';
export default connect(mapStateToProps, null, null, { forwardRef: true })(ref);
